<template>
  <div class="set-email">
    <div class="content-item">
      <set-people
        ref="SetPeople"
        multiple
        :data-range="['user', 'role', 'staffStructure', 'mail']"
        :people-group="flowConnectedData | screenPeople(true)"
        name="通知人员"
        :flow-info="nodeInfo"
        :project-id="workFlowData.appId"
        :app-id="workFlowData.appId"
        @addMail="addMail"
        @addEmailDefs="addEmailDefs"
        from="App"
      ></set-people>
    </div>
    <div class="content-item">
      <div class="item-title">
        邮件标题
        <span class="require-flag">*</span>
      </div>
      <textarea-editor
        class="item-text"
        v-model="subjectObj"
        :var-group="workflowVarGroupString"
        height="40"
      ></textarea-editor>
    </div>
    <div class="content-item">
      <div class="item-title">
        通知内容
        <span class="require-flag">*</span>
      </div>
      <textarea-editor
        class="item-text"
        v-model="contentObj"
        :var-group="workflowVarGroupString"
        min-height="160"
        max-height="400"
      ></textarea-editor>
    </div>
    <div class="content-item">
      <div class="item-title">
        附件
      </div>
      <tree-select multiple :group-list="fileMethods" v-model="fileList"></tree-select>
    </div>
  </div>
</template>

<script>
import TreeSelect from "@/components/UIComponents/TreeSelect"
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import SetPeople from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/SetPeople/SetPeople"
import Filters from "../../../mixin/filters"
import mixin from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/mixin"
import { filterTreeVarGroup } from "@/utils/workFlow"

export default {
  name: "setEmail",
  components: { SetPeople, TextareaEditor, TreeSelect },
  props: {
    nodeInfo: Object,
    workFlowData: Object,
    workflowVarGroup: Array,
    flowConnectedData: Array,
    workflowVarGroupString: Array,
    emailData: Object
  },
  data() {
    return {
      fileMethods: [],
      subjectObj: {},
      contentObj: {},
      fileList: [],
      emails: [],
      emailDefs: [],
      emailDefsExtra: []
    }
  },
  mixins: [Filters, mixin],
  computed: {},
  methods: {
    init() {
      this.fileMethods = filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) => control?._type === "file",
        mapFunc: option => ({
          label: option.label,
          value: option.value,
          sheetId: option.control.refSheetId,
          type: "data"
        })
      })
      this.subjectObj = {
        text: this.nodeInfo?.data?.mailMessage?.subject,
        arr: this.nodeInfo?.extra?.emailSubject
      }
      this.contentObj = {
        text: this.nodeInfo?.data?.mailMessage?.content,
        arr: this.nodeInfo?.extra?.emailContent
      }
      this.emails = this.nodeInfo?.data?.mailMessage?.emails
      this.fileList = this.nodeInfo?.data?.mailMessage?.fileList
      this.emailDefs = this.nodeInfo?.data?.mailMessage?.emailDefs
      this.emailDefsExtra = this.nodeInfo?.extra?.emailDefsExtra
      this.$nextTick(() => {
        this.$refs.SetPeople.init()
      })
    },
    beforeOutput() {
      if (!this.$refs.SetPeople.$data.people?.length && !this.$refs.SetPeople.$data.mails?.length)
        return { result: false, msg: "未选择人员或邮箱！" }
      if (!this.subjectObj.arr || this.subjectObj.arr.length === 0)
        return { result: false, msg: "未填写主题！" }
      if (!this.contentObj.arr || this.contentObj.arr.length === 0)
        if (!this.contentObj.arr || this.contentObj.arr.length === 0)
          return { result: false, msg: "未填写通知内容！" }
      return this.$refs.SetPeople.output()
    },
    addMail(mails) {
      this.emails = mails
    },
    addEmailDefs(emailDefs) {
      this.emailDefsExtra = [].concat(emailDefs || [])
      this.emailDefs = emailDefs.map(def => def.code)
    }
  }
}
</script>

<style lang="scss" scoped>
.set-email {
  .content-item {
    .item-title {
      font-weight: bold;
      margin: 22px auto 10px;
    }
  }
}
</style>
